import {
  SearchAuditEventsRequest,
  SearchAuditEventsResponse,
  API,
} from '@weave/schema-gen-ts/dist/apis/api/phone/audits/v1/api.pb';
import { bindHTTP } from '@frontend/schema';

export type SearchAuditEventsOptions = {
  baseUrl: string;
};

const SchemaPhoneAuditsService = bindHTTP(API);

export const searchAuditEvents = (
  req: SearchAuditEventsRequest,
  { baseUrl }: SearchAuditEventsOptions
): Promise<SearchAuditEventsResponse> => {
  return SchemaPhoneAuditsService.SearchAuditEvents(req, { baseUrl });
};
